import Vue from "vue";
import VueGtag from "vue-gtag";

/**
 * @see
 *  - https://matteo-gabriele.gitbook.io/vue-gtag/
 *  - https://www.nightprogrammer.com/vue-js/how-to-add-gtag-google-analytics-4-in-vue-js-nuxt-js-example/
 *  - https://www.carlcassar.com/articles/add-google-analytics-to-a-nuxt-js-app
 */
export default ({ app }) => {
    const { googleAnalytics } = app.$config;

    if (!googleAnalytics.id) {
        return;
    }

    Vue.use(VueGtag, {
        config: googleAnalytics,
        appName: "gm-app",
        pageTrackerScreenviewEnabled: true
    }, app.router);
};
